import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useOfferTemplates, OfferTemplate } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<OfferTemplate>
      useData={useOfferTemplates}
      config={{
        ...moduleConfig,
        getColumns: (formatDate) => getColumns(formatDate),
        getToolbarIcon,
        getTableActions: (item, onDelete, _c, _ctx, opts) => getTableActions(item, onDelete, _c, _ctx, opts),
      }}
    />
  );
};

export default List;
